<script>
export default {
  name: 'TeamRaisedAmount',
  props: {
    team: {
      type: Object,
      required: true
    }
  },
  computed: {
    raisedFormatted() {
      return this.$filters.formatCurrency(this.team.cached?.raised ?? this.team.raised, this.team.currency)
    },
    goalFormatted() {
      return this.$filters.formatCurrency(this.team.goal, this.team.currency)
    }
  }
}
</script>

<template>
  <div class="flex flex-wrap gap-2 justify-between items-end mb-2">
    <h2 class="text-2xl lg:text-3xl font-medium">
      {{ raisedFormatted }}
    </h2>
    <span class="text-sm font-medium mb-[2px]">
      {{ team.cached.percentage_raised_formatted }} of {{ goalFormatted }} goal
    </span>
  </div>
</template>

<style scoped>

</style>
